import React, { Component } from "react";
import {
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Fab,
  Divider
} from "@material-ui/core";
import { GoSearch } from "react-icons/go";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Dropdown from 'react-dropdown';
import Modal from "react-awesome-modal";
import "./ZonesTable.css";
import { GoogleComponent } from "react-google-location";
import { Map, Circle, GoogleApiWrapper } from "google-maps-react";
import firebase from "firebase/app";
import firestore from "firebase/firestore";
// import { firebaseConfig } from './Components/FirebaseConfig';
import { firebaseConfig } from "../FirebaseConfig";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import Geocode from "react-geocode";
import {
  BrowserRouter as Router,
  Link,
  Redirect,
  useHistory,
} from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
toast.configure();

export class ZonesTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      map_center: {
        //latlng for view map
        lat: 24.916624,
        lng: 67.074067,
      },
      Zones: [],
      zoom: 11,
      place: {},
      zones_latitude: "", //for create zones
      zones_longitude: "", //for create zones
      radius: null, //for create zones
      zones_type: null,
      updated_radius: null,
      updated_zones_type: null,
      address: "",
      placeholder: "Search Places ...",
      visible: false,
      startTime: "",
      endTime: "",
      key: 0,
      edit_uid: null,
      days:[],
      search:''

    };
    this.onInputChange = this.onInputChange.bind(this);

    this.onAddInputChange = this.onAddInputChange.bind(this);
    this._onAddSelect = this._onAddSelect.bind(this);

    this.onEditInputChange = this.onEditInputChange.bind(this);
    this._onEditSelect1 = this._onEditSelect1.bind(this);
  }

  componentDidMount() {
    this.getCordinates();
    // setInterval(() => {
    //     this.getCordinates();
    //     // console.warn("kdbcjkbckajs")
    // }, 1000

    // )
    // this.onChangeKey();
  }

  onAddInputChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  _onAddSelect(option) {
    // console.log('You selected ', option.label)
    this.setState({ zones_type: option.label })
  }

  onEditInputChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  _onEditSelect1(option) {
    // console.log('You selected ', option.label)
    this.setState({ updated_zones_type: option.label })
  }

  handleChange = (address) => {
    //send seaarch address
    this.setState({ address });
  };

  handleSelect = (address) => {
    //convert address to cordinates
    Geocode.setApiKey("AIzaSyB7Hwn_-eHX2Or_vobRHT0f4bejWcYPpx0");

    Geocode.setLanguage("en");
    Geocode.fromAddress(address).then(
      (response) => {
        const { lat, lng } = response.results[0].geometry.location;
        console.log(lat, lng);
        {
          this.setState({ zones_latitude: lat, zones_longitude: lng });
        }
      },
      (error) => {
        console.error(error);
      }
    );
    // console.log("ajkda: ",address);
    this.setState({ placeholder: address });
  };

  getCordinates = async () => {
    //get violations data from firebase
    console.log("func chal raha hai k nhe ")
    

    if (this.state.search == null || this.state.search == "" || this.state.search == '') {
      let tempdata = [];

      const db = firebase.firestore();
      const snapshot = await db
      .collection("zones")
      .orderBy("publishTime", "asc")
      .get();

      snapshot.forEach((doc) => {
        let tempobj = {
          uid: doc.id,
          latitude: doc.data().latitude,
          zones_type: doc.data().zones_type,
          longitude: doc.data().longitude,
          place: doc.data().place,
          radius: doc.data().radius,
          startTime: doc.data().startTime,
          endTime: doc.data().endTime,
          key: doc.data().key,
        };
        // tempdata.push(tempobj);
        if(tempobj.zones_type == "Mild")
        {
          tempdata.push(tempobj);
        }
        else
        {
          console.log("Not working")
        }
        
      });
      this.setState({ Zones: []});
      this.setState({ Zones: tempdata });
      
    } else {

      const db = firebase.firestore();
      let tempdata = [];

      const snapshot = await db
      .collection("zones")
      .orderBy("place", "desc")
      .where('place', '>=', this.state.search)
      .where('place', '<=', this.state.search+"\uf8ff")
      .get();

      snapshot.forEach((doc) => {
        let tempobj = {
          uid: doc.id,
          latitude: doc.data().latitude,
          zones_type: doc.data().zones_type,
          longitude: doc.data().longitude,
          place: doc.data().place,
          radius: doc.data().radius,
          startTime: doc.data().startTime,
          endTime: doc.data().endTime,
          key: doc.data().key,
        };
        // tempdata.push(tempobj);
        if(tempobj.zones_type == "Mild")
        {
          tempdata.push(tempobj);
        }
        else
        {
          console.log("Not working")
        }

      });

      this.setState({ Zones: []});
      this.setState({ Zones: tempdata });
      
    }
      
      // .where('cnic', '>=', this.state.search)
      // .where('cnic', '<=', this.state.search+"\uf8ff")
      // .startAt([this.state.search])
      // .endAt([this.state.search+"\uf8ff"])
     

    // snapshot.forEach((doc) => {
    //   let tempobj = {
    //     uid: doc.id,
    //     first_name: doc.data().first_name,
    //     last_name: doc.data().last_name,
    //     cnic: doc.data().cnic,
    //     fine: doc.data().fine,
    //     violation_status: doc.data().violation_status,
    //     zone_id: doc.data().zone_id,
    //     exit_time: doc.data().exit_time,
    //     exit_zone: doc.data().exit_zone,
    //     email: doc.data().email,
    //   };
    //   tempdata.push(tempobj);
    // });
    // this.setState({ violations: tempdata });
  };

  onInputChange = async(event) => {

    // let string = event.target.value.toLower
    if (event.target.value.length < 1) {
      event.target.value = '';
      // this.getViolationData()     
      console.log("if ki value =", event.target.value)
      this.setState({ [event.target.name]: event.target.value});

      let tempdata = [];

      const db = firebase.firestore();
      const snapshot = await db
      .collection("zones")
      .orderBy("publishTime", "asc")
      .get();

      snapshot.forEach((doc) => {
        let tempobj = {
          uid: doc.id,
          latitude: doc.data().latitude,
          zones_type: doc.data().zones_type,
          longitude: doc.data().longitude,
          place: doc.data().place,
          radius: doc.data().radius,
          startTime: doc.data().startTime,
          endTime: doc.data().endTime,
          key: doc.data().key,
        };
        // tempdata.push(tempobj);
        if(tempobj.zones_type == "Mild")
        {
          tempdata.push(tempobj);
        }
        else
        {
          console.log("Not working")
        }

      });
      this.setState({ Zones: []});
      this.setState({ Zones: tempdata });

    } else {
      console.log("else ki value =", event.target.value)
      this.setState({ [event.target.name]: event.target.value});
    }
    this.getCordinates()      
}

  // getCordinates = async () => {
  //   //get zones data from firebase
  //   let tempdata = [];
  //   const db = firebase.firestore();
  //   // db.initializeApp();
  //   const snapshot = await db.collection("zones").orderBy('publishTime',"desc").get();
  //   snapshot.forEach((doc) => {
  //     let tempobj = {
  //       uid: doc.id,
  //       latitude: doc.data().latitude,
  //       zones_type: doc.data().zones_type,
  //       longitude: doc.data().longitude,
  //       place: doc.data().place,
  //       radius: doc.data().radius,
  //       startTime: doc.data().startTime,
  //       endTime: doc.data().endTime,
  //       key: doc.data().key,
  //     };
      // if(tempobj.zones_type == "Mild")
      // {
      //   tempdata.push(tempobj);
      // }
      // else
      // {
      //   console.log("Not working")
      // }
  //     // tempdata.push(tempobj);
  //   });
  //   this.setState({ Zones: tempdata });
  // };

  deleteCordinates = async (delete_id) => {
    const db = firebase.firestore();
    const res = await db.collection("zones").doc(delete_id).delete();
    toast("Zone Deleted Successfull", {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 5000,
      hideProgressBar: true,
    });
    // await this.reloadPage();
    this.getCordinates();
  };

  updateRadius = async (update_id) => {
    console.log("Musibat= " + update_id)
    const db = firebase.firestore();
    const res = await db.collection('zones').doc(update_id).update
    ({ radius: parseInt(this.state.updated_radius), zones_type: this.state.updated_zones_type });
    // await this.reloadPage();
    toast('Zone Updated Successfull',
      {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 5000,
        hideProgressBar: true
      })
    this.getCordinates();

  }

  addCordinates = async () => {
    var today = Date()
    const db = firebase.firestore();
    const docRef = db.collection('zones').doc();
    await docRef.set({
      latitude: this.state.zones_latitude,
      longitude: this.state.zones_longitude,
      radius: parseInt(this.state.radius, 10),
      zones_type: this.state.zones_type,
      place: this.state.address,
      startTime: this.state.startTime,
      endTime: this.state.endTime,
      key: this.state.key,
      publishTime: today,
      days:this.state.days

    });
    toast('Zone Added Successfully',
      {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 5000,
        hideProgressBar: true
      })
    this.setState({
      radius: '',
      address: '',
    })
    // await this.reloadPage();
    this.getCordinates();

  }

  reloadPage = async () => {
    window.location.reload(true);
  };

  openEditModal(uid,radius,zones_type) {
    this.setState({
      edit_visible: true,
      edit_uid: uid,
      updated_radius:radius,
      updated_zones_type:zones_type
      // upda_radius:radius,
      // prev_zone_type:zones_type
    });
  }


  closeEditModal() {
    this.setState({
      edit_visible: false,
    });
  }

  openAddModal() {
    this.setState({
      add_visible: true,
    });
  }

  closeAddModal() {
    this.setState({
      add_visible: false,
    });
  }

 
  AddZonesValidation = () => {
    if (!this.state.address.trim()) {
      alert('Error. enter location')
      return;
    }
    if (!this.state.radius.trim()) {
      alert("Error: Please Enter Radius");
      return;
    }
    if (this.state.radius < 200) {
      alert("Error: Radius Must Be Greater Than 200");
      return;
    }
    if (this.state.zones_type == null) {
      alert("Error: Please Choose Zone Type");
      return;
    } else {
      this.closeAddModal()

      this.addCordinates();
    }
  };

  editZonesValidation = (uid) => {
    // this.closeAddModal()
   
    if (this.state.udated_radius < 200) {
      alert("Error: Radius Must Be Greater Than 200");
      return;
    }
    if (this.state.updated_zones_type == null) {
      alert("Error: Please Choose Zone Type");
      return;
    } 
    else {
      this.closeEditModal()
      this.updateRadius(uid);
    }
  };

  render() {
    const options = ["Critical", "Mild"];
    const defaultoption = this.state.updated_zones_type;

    return (
      <Paper className={"zonePaperCss"}>
        <div
          style={{
            height: "6.2vh",
            width: "100%",
            backgroundColor: "white",
            display:'flex',
            justifyContent:'flex-end',
            alignItems:'center',
            // marginBottom:'5%'
          }}
        >
          <div className={'zonesSearchInputDiv'}>
          <input
            className={'zonesSearchInput'}
            type={"text"}
            placeholder={"Search data..."}
            name={"search"}
            value={this.state.search}
            onChange={this.onInputChange}
          />
          <GoSearch style={{ height: 20, width: 20, color: '#21618C' }} />                            
          </div>
          
        </div>
        <TableContainer className={"zoneTableContainerCss"}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell align="center" className={"zoneTableCell"}>
                  NAME
                </TableCell>
                <TableCell align="center" className={"zoneTableCell"}>
                  RADIUS
                </TableCell>
                <TableCell align="center" className={"zoneTableCell"}>
                  TYPE
                </TableCell>
                <TableCell align="center" className={"zoneTableCell"}>
                  ACTIONS
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {this.state.Zones.map((value) => (
                <TableRow>
                  <TableCell align="left">{value.place}</TableCell>
                  <TableCell align="center">{value.radius}</TableCell>
                  <TableCell align="center">{value.zones_type}</TableCell>
                  <TableCell align="inherit">
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <EditIcon
                        className={'zoneEditDeleteIcon'}
                        onClick={() => this.openEditModal(value.uid, value.radius, value.zones_type)}
                      />

                      <Divider
                        orientation="vertical"
                        flexItem
                        variant="middle"
                      />

                      <DeleteIcon
                        className={'zoneEditDeleteIcon'}
                        onClick={() => {this.deleteCordinates(value.uid);}}
                      />

                    </div>

                    <Modal
                      visible={this.state.edit_visible}
                      width="50%"
                      height="300px"
                      border-radius='0.8vh'
                      onClickAway={() => this.closeEditModal()}
                    >
                      <div className={'zoneEditModelDiv'}>
                      <p style={{ fontWeight: 'bold', color: 'white', textDecoration: 'underline', marginTop: '-2vh', fontSize: '3.5vh' }}>UPDATE ZONE</p>

                        <div className={'zoneEditInput'}>

                          <div className={'zoneEditInputBox'} /*input radius div*/>
                            <input className={'zoneEditInput1'}
                              type={'text'}
                              placeholder={'Radius...'}
                              name={'updated_radius'}
                              value={this.state.updated_radius}
                              onChange={this.onEditInputChange}
                            />
                          </div>

                          <div className={'zoneEditDropdownBox'} >
                            <Dropdown
                              options={options} controlClassName='editControlClassName' className={'editClassName'}
                              onChange={this._onEditSelect1}
                              value={defaultoption}   
                              menuClassName='editMenuClassName'
                              placeholder="Select Zone Type"
                              placeholderClassName='editPlaceholderClassName'
                            />
                          </div>
                        </div>

                        <div className={'zoneEditButtonsDiv'}>
                        {/* <a href="javascript:void(0);" style={{ height: '5vh', width: '20%' }} > */}

                        <button className={'zoneEditButton'}
                            onClick={() => this.editZonesValidation(this.state.edit_uid)}
                          >
                            Update
                          </button>
                          {/* </a> */}

                        </div>

                      </div>
                    </Modal>

                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>  
        </TableContainer>

        <div style={{ position: "fixed", zIndex: '1', bottom: '5vh', right: '7vh' }}>
          <Fab
            size="large"
            aria-label="add"
            position="fixed"
            style={{ backgroundColor: "#6699ff", color: "white" }}
            onClick={() => this.openAddModal()}
          >
            <AddIcon />
          </Fab>
        </div>

        <Modal
          visible={this.state.add_visible}
          onClickAway={() => this.closeAddModal()}
          height="300px"
          width="80%"
          border-radius='0.8vh'
        >
          <div className={"zoneModelDiv"}>
            <p style={{ fontWeight: 'bold', color: 'white', textDecoration: 'underline', marginTop: '-2vh', fontSize: '3.5vh' }}>ADD ZONE</p>
            <div className={"zoneAddInput"}>
              <div className={"searchBar"}>
                <PlacesAutocomplete
                  value={this.state.address}
                  onChange={this.handleChange}
                  onSelect={this.handleSelect}
                >
                  {({
                    getInputProps,
                    suggestions,
                    getSuggestionItemProps,
                    loading,
                  }) => (
                    <div>
                      <input
                        {...getInputProps({
                          placeholder: "Search Places ...",
                          className: "location-search-input",
                        })}
                      />
                      <div className="autocomplete-dropdown-container">
                        {loading && <div>Loading...</div>}
                        {suggestions.map((suggestion) => {
                          const className = suggestion.active
                            ? "suggestion-item--active"
                            : "suggestion-item";
                          // inline style for demonstration purpose
                          const style = suggestion.active
                            ? {
                              backgroundColor: "white",
                              cursor: "pointer",
                              height: "auto",
                              alignItems: "center",
                              display: "flex",
                              border: "0.4vh solid #026e7a",
                            }
                            : {
                              backgroundColor: "#fafafa",
                              cursor: "pointer",
                              height: "auto",
                              alignItems: "center",
                              display: "flex",
                              border: "0.2vh solid grey",
                            };
                          return (
                            <div
                              {...getSuggestionItemProps(suggestion, {
                                className,
                                style,
                              })}
                            >
                              <span>{suggestion.description}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </PlacesAutocomplete>
              </div>

              <div className={'zoneAddInputBox'} >
                <input className={'zoneAddInput1'}
                  type={'text'}
                  placeholder={'Radius...'}
                  name={'radius'}
                  value={this.state.radius}
                  onChange={this.onAddInputChange}
                  // minLength={3}
                />
              </div>

              <div className={'zoneAddDropdownBox'} >

                <Dropdown
                  options={options} controlClassName='myMapControlClassName' className={'myMapClassName'}
                  onChange={this._onAddSelect}
                  //  value={defaultOption}   
                  menuClassName='myMapMenuClassName'
                  placeholder="Select Zone Type"
                  placeholderClassName='myPlaceholderClassName'
                />
              </div>
            </div>

            <div className={"zoneAddButtonsDiv"}>
              <button
                className={"zoneAddButton"}
                onClick={() => this.AddZonesValidation()}
              >
                ADD
              </button>
            </div>
          </div>
        </Modal>

      </Paper>
    );
  }
}
// export default ZonesTable;
export default GoogleApiWrapper({
  apiKey: "AIzaSyAVQwOjH20vishb4O-SGBQ3pi_3Q24pqbw",
})(ZonesTable);
